import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-3 mb-5 px-3 md:px-0 gap-3"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]

export function render(_ctx, _cache) {
  return (_ctx.hasPromotions)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotions, (promo, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: promo.id || index
          }, [
            (promo.href)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: promo.href,
                  class: "block"
                }, [
                  _createElementVNode("img", {
                    src: promo.image,
                    alt: promo.alt || promo.name,
                    class: "w-full"
                  }, null, 8 /* PROPS */, _hoisted_3)
                ], 8 /* PROPS */, _hoisted_2))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: promo.image,
                  alt: promo.alt || promo.name,
                  class: "w-full"
                }, null, 8 /* PROPS */, _hoisted_4))
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}